import React, { Component } from "react";
import styled from "styled-components";

//Views
import { NavBar } from "./NavBar.js";
import MenuMobile from "./MenuMobile.js";
import { ContactBlock } from "./ContactBlock.js";
import { Footer } from "./Footer.js";

import Loading from "../../Animations/Loading.js";

import AOS from "aos";

import "aos/dist/aos.css";
import NanoFlex from "../../Global/NanoFlex.js";
import Type from "../../Global/Typography.js";

const StyledLayout = styled.div`
  overflow: ${(props) => (!props.scrollable ? "hidden" : "auto")};
  height: ${(props) => (!props.scrollable ? "100%" : "auto")};
  overflow-x: hidden;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  position: relative;

  .hide {
    display: none !important;
  }
`;

export class Layout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMenuBurgerOpen: false,
      loading: false,
    };
  }

  componentDidMount() {
    window.addEventListener("load", this.handleLoad);
    window.addEventListener("setGlobalLoading", this.setGlobalLoading);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.render !== this.props.render) {
      this.scrollInto();
      this.onMenuBurgerOpenChange(false);
    }
  }

  componentWillUnmount() {
    window.removeEventListener("load", this.handleLoad);
    window.removeEventListener("setGlobalLoading", this.setGlobalLoading);
  }

  handleLoad = () => {
    this.scrollInto();
  };

  scrollInto = () => {
    setTimeout(() => {
      let element = this.props.render.location.hash;
      if (element && element.trim() !== "" && element.trim() !== "#") {
        let el = document.getElementById(element.substring(1));
        let yOffset = document.getElementsByClassName("navItem")[0].clientHeight * -1;
        let y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: "smooth" });
      } else {
        window.scrollTo(0, 0);
      }
    }, 250);
  };

  setGlobalLoading = (e) => {
    this.setState({ loading: e.detail ?? false });
  };

  onMenuBurgerOpenChange = (val) => {
    this.setState({ isMenuBurgerOpen: val });
  };

  render() {
    AOS.init({
      duration: 1200,
      once: true,
    });

    return (
      <StyledLayout flexDirection={"column"} alignItems={"flex-start"} alignContent={"flex-start"} justifyContent={"flex-start"} scrollable={!this.state.isMenuBurgerOpen}>
        {this.state.loading && <Loading />}
        <NavBar formationDetail={this.props.formationDetail} menuBurgerOpen={this.state.isMenuBurgerOpen} onMenuBurgerOpenChange={this.onMenuBurgerOpenChange} />
        <MenuMobile menuBurgerOpen={this.state.isMenuBurgerOpen} onMenuBurgerOpenChange={this.onMenuBurgerOpenChange} />
        {React.cloneElement(this.props.children, { render: this.props.render })}
        <ContactBlock contactImage={this.props.contactImage} />
        <Footer />
      </StyledLayout>
    );
  }
}
